import SearchDataProvider from './SearchDataProvider';
import SearchLoading from './SearchLoading';
import { withUserAndBaseData } from '../../lib';

export default withUserAndBaseData(SearchDataProvider, {
  showError: true,
  Fallback: SearchLoading,
});
